const ColorRules = {
    1: {
        rule: 'ONE_HOUR',
    },
    3: {
        rule: 'THREE_HOURS',
    },
    12: {
        rule: 'TWELVE_HOURS',
    },
    24: {
        rule: 'ONE_DAY',
    },
    48: {
        rule: 'TWO_DAYS',
    },
    '48+': {
        rule: 'OVER_TWO_DAYS',
    },
    '-1': {
        rule: 'OVERDUE',
    },
}
function colorRules (time) {
    const Rules = Object.keys(ColorRules)
    for (let index = 0; index < Rules.length; index++) {
        const element = Rules[index]
        if (element >= time) {
            return ColorRules[element].rule
        }
    }
    return ColorRules['48+'].rule
}
module.exports = {
    reloadRulesCor: (appointments) => {
        for (const prop in appointments) {
            const datetime = (Date.parse(appointments[prop].date) - Date.now()) * 0.000000278
            if (datetime > 0 && appointments[prop].status == 'OPEN') {
                appointments[prop].rule = colorRules(datetime)
            } else {
                if (appointments[prop].status == 'OPEN') {
                    appointments[prop].rule = ColorRules['-1'].rule
                } else {
                    appointments[prop].rule = null
                }
            }
        }
        return appointments
    },
}
